function autoMapping<TSource, TDestination>(source: TSource, defaultDestination: TDestination): TDestination {
    const destination: TDestination = { ...defaultDestination };
    // @ts-expect-error old function with no description
    Object.keys(destination).forEach((key) => {
        const value = source[key as keyof TSource];
        if (value !== undefined) {
            // @ts-expect-error old function with no description
            destination[key as keyof TDestination] = value;
        }
    });
    return destination;
}

export default autoMapping;
